"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = exports.AccessType = exports.AccessAction = exports.UserType = exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["USER"] = "user";
    UserRole["ADMIN"] = "admin";
})(UserRole || (exports.UserRole = UserRole = {}));
var UserType;
(function (UserType) {
    UserType["USER"] = "user";
    UserType["TEAM"] = "team";
})(UserType || (exports.UserType = UserType = {}));
var AccessAction;
(function (AccessAction) {
    AccessAction["MANAGE"] = "manage";
    AccessAction["CREATE"] = "create";
    AccessAction["READ"] = "read";
    AccessAction["UPDATE"] = "update";
    AccessAction["DELETE"] = "delete";
    AccessAction["ACCESS"] = "access";
})(AccessAction || (exports.AccessAction = AccessAction = {}));
var AccessType;
(function (AccessType) {
    AccessType["PUBLIC"] = "public";
    AccessType["PRIVATE"] = "private";
    AccessType["PROTECTED"] = "protected";
})(AccessType || (exports.AccessType = AccessType = {}));
var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "info";
    LogLevel["ERROR"] = "error";
    LogLevel["DEBUG"] = "debug";
    LogLevel["WARNING"] = "warning";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
__exportStar(require("./app-project.js"), exports);
__exportStar(require("./errors.js"), exports);
__exportStar(require("./subscription.js"), exports);
__exportStar(require("./track-events.js"), exports);
__exportStar(require("./access-request.js"), exports);
